import { styled } from '@mui/material/styles';
import Link, {LinkProps} from "@mui/material/Link";
import {Link as RouterLink} from 'react-router-dom';


export const PrimaryLink = styled(RouterLink)<LinkProps>(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,
  '&:hover': {
      backgroundColor: theme.palette.primary.dark,
  },
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  lineHeight: theme.spacing(6),
  textDecoration: 'none',
  cursor: 'pointer',
}));

export const SecondaryLink = styled(RouterLink)<LinkProps>(({ theme }) => ({
  color: theme.daPalette.black.contrastText,
  backgroundColor: theme.daPalette.black.main,
  '&:hover': {
      backgroundColor: theme.daPalette.black.light,
  },
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  lineHeight: theme.spacing(6),
  textDecoration: 'none',
  cursor: 'pointer',
}));


export const LogoLink = styled(RouterLink)<LinkProps>(({ theme }) => ({
  color: theme.daPalette.black.contrastText,
  height: theme.spacing(4),
  cursor: 'pointer',
}));